/**
 * Google Analytics 4 Utilities & Events
 */

if (typeof window.pushDataLayerEvent !== 'function') {
  window.pushDataLayerEvent = obj => {
    // Fallback for dataLayer
    window.dataLayer = window.dataLayer || [];

    // Clear the previous ecommerce object.
    window.dataLayer.push({ ecommerce: null });

    // Push new ecommerce dataLayer event
    window.dataLayer.push(obj);
  }
}

/**
 * GA4 DataLayer: custom event menu_open
 */
window.GA4_menu_open = (properties) => {
  try {
    pushDataLayerEvent({
      event: 'menu_open',
      ...properties
    });
  } catch (error) {
    console.log('GA4: menu_open', error);
  }
}

/**
 * GA4 DataLayer: custom event menu_click
 */
window.GA4_menu_click = (properties) => {
  try {
    pushDataLayerEvent({
      event: 'menu_click',
      ...properties
    });
  } catch (error) {
    console.log('GA4: menu_click', error);
  }
}